import { motion } from "framer-motion";

interface InfoBannerProps {
  message: string;
}

export default function InfoBanner({ message }: InfoBannerProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="relative max-w-2xl mx-auto"
    >
      {/* <Link
        href="/vote#votelist"
        onClick={(e) => {
          e.preventDefault();
          document
            .getElementById("votelist")
            ?.scrollIntoView({ behavior: "smooth" });
        }}
        className="absolute -top-4 left-1/2 transform -translate-x-1/2 z-10"
      >
        <div className="relative overflow-hidden bg-gradient-to-r from-purple-400 to-indigo-400 px-4 py-1 rounded-full shadow-lg active:scale-95 transition-transform ">
          <span className="text-xs font-bold uppercase tracking-wider text-indigo-50 text-nowrap flex justify-center items-center ">
            <span className="px-4"> Explore Now</span>
            <ChevronRight size={22} className="animate-floattopright" />
          </span>
          <div className="absolute animate-shimmer-swipe-loop inset-0 opacity-100 bg-gradient-to-r from-transparent via-white/70 to-transparent "></div>
        </div>
      </Link> */}

      <div className="relative overflow-hidden rounded-2xl border border-indigo-300/30 bg-gradient-to-br from-indigo-900/20 via-purple-900/20 to-black/30 backdrop-blur-md p-4 pt-5 shadow-[0_8px_32px_rgba(31,38,135,0.25)]">
        <div className="flex items-center justify-center space-x-3">
          <p className="text-center text-lg text-white font-medium tracking-wide leading-relaxed">
            {message}
          </p>
        </div>

        <div className="absolute inset-0 bg-gradient-to-r from-indigo-500/5 to-purple-500/5 rounded-2xl animate-pulse-slow"></div>
      </div>
    </motion.div>
  );
}
